import { buildValidations, validator } from 'ember-cp-validations';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Model, { attr, belongsTo } from '@ember-data/model';
import pristine from 'client-portal/utils/macros/pristine';

export const MAX_MESSAGE_LENGTH = 600;

const Validations = buildValidations({
  message: [
    validator('length', {
      max: MAX_MESSAGE_LENGTH,
      descriptionKey: 'errors.reservation.message',
      messageKey: 'errors.lengthExceeded',
    }),
  ],
});

export default class ReservationModel extends Model.extend(Validations) {
  @belongsTo('practice', { async: false, inverse: null }) practice;
  @belongsTo('clinician', { async: false, inverse: null }) clinician;
  @belongsTo('cpt-code', { async: false, inverse: null }) cptCode;
  @belongsTo('office', { async: false, inverse: null }) office;
  @belongsTo('global-monarch-channel', { async: false, inverse: null }) channel;
  @attr('moment') startTime;
  @pristine('startTime') pristineStartTime;

  hasCompletedMessageStep = false;
  hasCompletedInformationStep = false;
  insurancePaymentMethod = 'No response';

  @tracked clientType = null;

  get endTime() {
    if (!this.pristineStartTime) {
      return null;
    }

    return this.pristineStartTime.clone().add(this.cptCode?.duration, 'minutes');
  }

  // Keep as classic @computed so `time-spots`'s `@oneWay('reservation.isReserved')`
  // stays reactive when either @attr changes.
  @computed('startTime', 'pristineStartTime')
  get isReserved() {
    return this.startTime && this.pristineStartTime;
  }

  get isCreditCardRequired() {
    let { isCreditCardRequired, isCreditCardRequirementUnset } = this.cptCode || {};
    let { requireCreditCardForNewClients } = this.practice;
    return isCreditCardRequired || (isCreditCardRequirementUnset && requireCreditCardForNewClients);
  }
}
